export const shadow = `0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)`;
export const shadowSm = `0 1px 2px 0 rgb(0 0 0 / 0.05)`;
export const shadowMd = `0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)`;
export const shadowLg = `0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)`;
export const shadowXl = `0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)`;
export const shadow2Xl = `0 25px 50px -12px rgb(0 0 0 / 0.25)`;
export const shadowInner = `inset 0 2px 4px 0 rgb(0 0 0 / 0.05)`;
